import React, { useContext, useEffect } from "react";
import Services from "./Services";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import keycloakData from "../api/apps/keycloakData";
import axios from "axios";
import CryptoJS from "crypto-js";
// import JSEncrypt from "jsencrypt";
import {
  CISO_BASE_URL,
  ARMS_BASE_URL,
  ASSESSMENT_BASE_URL,
  CTF_BASE_URL,
  LMS_BASE_URL,
  DIGITAL_NAGRIK_BASE_URL,
  VLABS_BASE_URL,
  ARMS_PUBLIC_URL,
  CISO_PUBLIC_URL,
} from "../api/apps/baseUrls";
import base32 from "hi-base32";
import MainContext from "./Context/MainContext";

// import JSZip from "jszip";
// import forge from "node-forge";

// const secreteKeysForApiEncryption =
//   "3f3a2f4c6a89b0c9eb1294cb9da02cc287ef8f01c2c9997d1b7c1f7bc3a0f799";

const backendPublicKey = process.env.ENCRYPTION_DECRYPTION_PUBLIC_KEY;
const frontendPrivateKey = process.env.DECRYPTION_ENCRYPTION_PRIVATE_KEY;

export function setLocalStorage(key, value) {
  localStorage.setItem(key, value);
}
export function getLocalStorage(key) {
  //return  sessionStorage.getItem(key);
  return localStorage.getItem(key);
}

export function setCookies(key, value, options) {
  Cookies.set(key, value, options);
}

export function getCookies(key) {
  //return  sessionStorage.getItem(key);
  return Cookies.get(key);
}

// ====================TIME FORMAT===================================
export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

export function userLogin() {
  const bodyjson = {
    client_id: keycloakData.ivp_clientID,
    client_secret: keycloakData.ivp_client_secret,
  };
  // console.log("env", bodyjson);
  Services.keyCloak_codeGen(bodyjson)
    .then(async (response) => {
      if (response.data.status === 1) {
        // console.log("Main response", response.data.data.url);
        let codeURL = response.data.data.url;
        // this.setState({ codeURL: this.state.codeURL });
        // console.log("url", codeURL);
        window.open(codeURL, "_blank");
      } else {
        // console.log("login error", response);
        Swal.fire({
          title: "Error",
          text: response.data.errorMsg,
          icon: "error",
        });
      }
    })
    .catch((err) => {
      // console.log("patch error", err);

      Swal.fire({
        title: "Error",
        // text: err,
        text: err.response.status === 500 ? "Server not reachable" : err,
        icon: "error",
      });
    });
}

export function addOrUpdateParam(key, value) {
  let params = {};
  params[key] = value;
  return params;
}

export function userRedirectLogin(bodyjson) {
  const redirectURL = Services.redirectURL(bodyjson);
  window.open(redirectURL, "_blank");
}
export function redirectURLWithParamsValue(bodyjson) {
  const redirectURL = Services.redirectURLWithParams(bodyjson);
  window.open(redirectURL, "_blank");
}

export function redirectURLWithExtraParams(bodyjson, params) {
  const redirectURL = Services.redirectURLWithExtraParamsValue(
    bodyjson,
    params
  );
  window.open(redirectURL, "_blank");
}

export async function userLogout(uid) {
  const cookiesRefToken = Cookies.get("refToken");
  // const userID = localStorage.getItem("id");
  const userID = uid;

  // const bodyjson = {
  //   refresh_token: cookiesRefToken,
  // };
  // try {
  //   const response = await Services.logoutUser(bodyjson);
  //   if (response.status === 200) {
  //     window.localStorage.clear();
  //     Cookies.remove("ac_token");
  //     Cookies.remove("refToken");
  //     localStorage.clear();
  //     window.location.href = "/";

  //   } else {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Logout Failed",
  //       text: `Server responded with Connection Failed`,
  //     });
  //   }
  // } catch (err) {
  //   if (err.response && err.response.status) {
  //     const errorMessage = err.response.data?.errors || "An error occurred";
  //     if (err.response.status === 400) {
  //       console.log("400");
  //       Swal.fire({
  //         title: "Error",
  //         text: errorMessage,
  //         icon: "error",
  //       });
  //     } else if (err.response.status === 501) {
  //       Swal.fire({
  //         title: "Error",
  //         text: errorMessage,
  //         icon: "error",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Logout Failed",
  //         text: "Server responded with status Network Connection",
  //       });
  //     }
  //   } else {
  //     if (err.message.includes("Failed to fetch")) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Network Error",
  //         text: "Unable to connect to the server. Please check your network connection.",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "An Error Occurred",
  //         text: `An unexpected error occurred: Connection Refused`,
  //       });
  //     }
  //   }
  //   console.error("An error occurred during logout:", err);
  // }
  // useEffect(() => {
  const secretKey =
    "6e0c6d0d6a1e3a1b9a1d5a2e4b7f8e0f9c0d8f7b9a3e4d1e6b2f4a3e5b7c8d1b";
  const storedEncryptedValue = getLocalStorage("client");

  const logout = async () => {
    const bodyjson = {
      refresh_token: cookiesRefToken,
      user_id: userID,
    };
    // console.log("bodyjson", bodyjson);
    try {
      const response = await Services.logoutUser(bodyjson);
      if (response.status === 200) {
        window.localStorage.clear();
        Cookies.remove("ac_token");
        Cookies.remove("refToken");

        localStorage.clear();

        if (storedEncryptedValue) {
          // const decryptedValue = decryptAES(storedEncryptedValue, secretKey);
          // console.log("decryptedValue", decryptedValue);

          switch (storedEncryptedValue) {
            case "ivp":
              window.location.href = "/";
              break;
            case "quiz":
              window.location.href = ASSESSMENT_BASE_URL;
              break;
            case "ciso":
              window.location.href = CISO_PUBLIC_URL;
              break;
            case "forms":
              window.location.href = ARMS_PUBLIC_URL;
              break;
            case "ctf":
              window.location.href = CTF_BASE_URL;
              break;
            case "cyberkid":
              window.location.href = LMS_BASE_URL;
              break;
            case "digitalnagriks":
              window.location.href = DIGITAL_NAGRIK_BASE_URL;
              break;
            case "elearning":
              window.location.href = LMS_BASE_URL;
              break;
            case "malwareAnalysis":
              window.location.href = "https://sandbox.isea.app/";
              break;
            case "vlab":
              window.location.href = VLABS_BASE_URL;
              break;
            default:
              window.location.href = "/";
              break;
          }
        } else {
          console.log("No encrypted text found");
          window.location.href = "/";
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Logout Failed",
          text: `Server responded with Connection Failed 200 else`,
        });
      }
    } catch (err) {
      if (err.response && err.response.status) {
        const errorMessage = err.response.data?.errors || "An error occurred";
        if (err.response.status === 400) {
          console.log("400");
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
          });
        } else if (err.response.status === 501) {
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Already Logged out",
            text: "Session Timed out, Kindly login again",
          }).then(() => {
            window.localStorage.clear();
            Cookies.remove("ac_token");
            Cookies.remove("refToken");

            localStorage.clear();
            window.location.href = "/";
            // userLogout();
          });
        }
      } else {
        if (err.message.includes("Failed to fetch")) {
          Swal.fire({
            icon: "error",
            title: "Network Error",
            text: "Unable to connect to the server. Please check your network connection. 2",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "An Error Occurred",
            text: `An unexpected error occurred: Connection Refused 3`,
          });
        }
      }

      console.error("An error occurred during logout:", err);
    }
  };

  logout();
  // }, []);
}
export function statusChangedToIC() {
  const allContextDetails = useContext(MainContext);
  const roleChanged = allContextDetails.status;
  const deletedCoordinator = allContextDetails.is_deleted;

  useEffect(() => {
    if (roleChanged === "approved" && deletedCoordinator === "1") {
      Swal.fire({
        title: "Success",
        text: `Your Request is approved by admin and role is changed to Coordinator of ${allContextDetails.institute_name}`,
        icon: "success",
      }).then(() => {
        userLogout();
      });
    }
  }, [roleChanged]);
}
export function statusChangedToUser() {
  const allContextDetails = useContext(MainContext);
  const roleChanged = allContextDetails.status;
  const deletedCoordinator = allContextDetails.is_deleted;

  useEffect(() => {
    if (roleChanged === "NotRequested" && deletedCoordinator === "2") {
      // console.log("ststus", roleChanged, deletedCoordinator);
      Swal.fire({
        title: "Warning",
        text: `Admin changed your role to user, Kindly contact to Admin`,
        icon: "warning",
      }).then(() => {
        userLogout();
      });
    }
  }, [roleChanged]);
}

export function sessionVerifyToLogout() {
  const userID = localStorage.getItem("id");

  const bodyjson = {
    // token: cookiesRefToken,
    user_id: userID,
  };
  Services.sessionVerifyLogout(bodyjson)
    .then(async (response) => {
      if (response.data.status === 0) {
        userLogout();
        console.log("session verify", response);
      } else {
        console.log("error occured during app logout");
      }
      console.log("session verify", response);
    })
    .catch((error) => {
      console.log("error occured during logout", error);
    });
}
// ========================= global error ===============================
export function displayErrorMessages(errorMsg) {
  let errorMessage = "";
  Object.keys(errorMsg).forEach((field) => {
    errorMessage += errorMsg[field] + "\n";
  });
}

export function displayErrorFormatMessages(errorMsg) {
  if (!errorMsg) return null;
  let tableData = {};

  errorMsg.forEach((errorObj) => {
    Object.entries(errorObj).forEach(([email, messages]) => {
      if (!tableData[email]) {
        tableData[email] = [];
      }
      tableData[email] = [...tableData[email], ...messages];
    });
  });

  let formattedTable = Object.entries(tableData).map(([email, messages]) => ({
    Email: email,
    Errors: messages.join("\n"),
    // Errors: messages.map((msg) => msg.replace(/\. /g, ".\n")).join("\n"),
  }));

  return formattedTable;
}

//  =========================== Global list style========================
export function applyListStyles(html) {
  const container = document.createElement("div");
  container.innerHTML = html;

  const ulElements = container.querySelectorAll("ul");
  ulElements.forEach((ul) => {
    ul.classList.add("bullet-list");
  });

  const olElements = container.querySelectorAll("ol");
  olElements.forEach((ol) => {
    ol.classList.add("numbered-list");
  });

  return container.innerHTML;
}
// ============================== Encryption =================================
export const generateHmacSHA512 = (message, secretKey) => {
  return CryptoJS.HmacSHA512(message, secretKey).toString(CryptoJS.enc.Hex);
};

export const encryptAES = (message, secretKey) => {
  return CryptoJS.AES.encrypt(message, secretKey).toString();
};
// ============================== De cryption =================================
export const verifyHmacSHA512 = (message, secretKey, hash) => {
  const computedHash = generateHmacSHA512(message, secretKey);
  return computedHash === hash;
};
// export const decryptAES = (ciphertext, secretKey) => {
//   const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
//   return bytes.toString(CryptoJS.enc.Utf8);
// };

export const decryptAES = (ciphertext, secretKey) => {
  console.log("ctext", ciphertext);
  console.log("skey", secretKey);

  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    console.log(" bytes", bytes);

    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    console.log(" originalText", originalText);

    if (!originalText) throw new Error("Decryption failed");
    return originalText;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

// =========================================Encrypt for AES =================
export const encryptAESForApi = (userEmail, secreteKeysForApiEncryption) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(
      userEmail,
      secreteKeysForApiEncryption
    ).toString();
    // console.log("--------------", encryptedValue);
    return encryptedValue;
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
//  ============================ Features Permissions =============================
export const hasPermission = (permissions, featureName, permissionName) => {
  const feature = permissions.find((f) => f.feature_name === featureName);
  if (!feature) return false;

  const permission = feature.permissions.find(
    (p) => p.permission === permissionName
  );
  return permission ? permission.value : false;
};
// ============================================ PAYLOAD_ENCRYPTION ====================================================

const secureKey = process.env.SECURE_KEY;
const secureIV = process.env.SECURE_IV;

const key = CryptoJS.enc.Utf8.parse(secureKey); // 32-byte key
const iv = CryptoJS.enc.Utf8.parse(secureIV); // 16-byte IV

export function encryptData(plainText) {
  const str = JSON.stringify(plainText);
  const encrypted = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // base64
}

export function decryptData(encryptedBase64) {
  // const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // });

  // return decrypted.toString(CryptoJS.enc.Utf8);
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

    // decryptedString = decryptedString
    //   .replace(/'/g, '"') // Replace single quotes with double quotes
    //   .replace(/\bTrue\b/g, "true") // Replace True with true
    //   .replace(/\bFalse\b/g, "false") // Replace False with false
    //   .replace(/\bNone\b/g, "null"); // Replace None with null

    // console.log("decryptedJson", decryptedJson);
    // const decryptedJson = JSON.parse(decryptedString);

    return decryptedString;
  } catch (error) {
    console.error("Decryption or JSON parsing failed:", error);
    return null;
  }
}
